<template>
        <div>
        <b-form-checkbox v-model="value" :name="`formData[${currentField.tagname}]`" switch :required="this.currentField.isRequired" :class="{'is-invalid' : error}">
              <b>{{ value ? currentField.activeText : currentField.inActiveText }}</b>
            </b-form-checkbox>
            <span class="invalid-feedback" role="alert" v-if="error">
                <strong>{{ error }}</strong>
            </span>
        </div>
</template>


<script>
export default {
  name: 'elswitch',
  props: ['currentField', 'error'],
  watch: {
    value(value) {
      this.$emit('updated', {
        key: this.currentField.tagname,
        value,
      })
    }
  },

  watch: {
    value (value) {
      this.value = value ?? true
    }
  },

  data() {
    return {
      value: true
    }
  }
}
</script>
